import Icon from "./IconBase.js";
const AudioIcon = (props) => {
  return (
    <Icon
      width="18"
      height="18"
      viewBox="0 0 18 18"
      style={{ borderColor: "white" }}
      {...props}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 17 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.99561 10.5C3.4398 10.4994 4.03743 10.4184 4.04607 9.89542V5.69798C4.09377 3.45101 6.07311 1.62313 8.45771 1.62313C9.63718 1.62313 10.7454 2.05584 11.5781 2.84145C12.3875 3.60511 12.8462 4.61945 12.8694 5.68659V9.89526C12.8784 10.4185 13.4754 10.4991 13.9199 10.4998C15.503 10.5 16.7912 9.28467 16.7912 7.79108C16.7912 6.32657 15.5506 5.13723 14.01 5.09109C13.8504 3.94234 13.3001 2.87771 12.4198 2.0475C11.3622 1.04955 9.95511 0.5 8.45785 0.5C5.6429 0.5 3.27613 2.50703 2.90741 5.09086C1.36589 5.13612 0.124512 6.32596 0.124512 7.79111C0.124512 9.2847 1.41266 10.5 2.99578 10.5H2.99561ZM15.6009 7.79111C15.6009 8.62081 14.9217 9.30389 14.0602 9.37144V6.21117C14.9217 6.27849 15.6009 6.96129 15.6009 7.79111ZM2.85581 6.21104V9.37131C1.9943 9.30387 1.31508 8.62081 1.31508 7.79111C1.31508 6.96129 1.9943 6.27847 2.85581 6.21104Z"
          fill="#757575"
        />
        <path
          d="M7.86182 5.64386V9.9382C7.86182 10.2483 8.12835 10.4998 8.45706 10.4998C8.78578 10.4998 9.05231 10.2483 9.05231 9.9382V5.64386C9.05231 5.33373 8.78578 5.08228 8.45706 5.08228C8.12835 5.08228 7.86182 5.33373 7.86182 5.64386Z"
          fill="#757575"
        />
        <path
          d="M10.2432 6.94855V8.6333C10.2432 8.94342 10.5097 9.19488 10.8384 9.19488C11.1671 9.19488 11.4337 8.94342 11.4337 8.6333V6.94855C11.4337 6.63842 11.1671 6.38696 10.8384 6.38696C10.5097 6.38696 10.2432 6.63842 10.2432 6.94855Z"
          fill="#757575"
        />
        <path
          d="M5.48145 6.94855V8.6333C5.48145 8.94342 5.74798 9.19488 6.07669 9.19488C6.40541 9.19488 6.67194 8.94342 6.67194 8.6333V6.94855C6.67194 6.63842 6.40541 6.38696 6.07669 6.38696C5.74798 6.38696 5.48145 6.63842 5.48145 6.94855Z"
          fill="#757575"
        />
      </svg>
    </Icon>
  );
};
export default AudioIcon;
